import { Divider, Stack, Typography } from '@mui/material';

import { SummaryCardNew } from '@hapvida/hapvida-core-components';

import useDeviceBreakpoints from 'hooks/useDeviceBreakpoints';

import {
  ResponsibilityLetterContent,
  ResponsibilityLetterInfo,
} from './components';

export function ResponsibilityLetterLayout() {
  const { isMobileOrTablet } = useDeviceBreakpoints();

  return (
    <Stack paddingTop={3} paddingBottom={8}>
      <SummaryCardNew.Container>
        <Stack gap={4} padding={isMobileOrTablet ? 0 : 2}>
          <Typography variant="h6">Carta de Responsabilidade</Typography>

          <ResponsibilityLetterInfo />

          <Divider sx={{ my: 2 }} />

          <ResponsibilityLetterContent />
        </Stack>
      </SummaryCardNew.Container>
    </Stack>
  );
}
